import { render, staticRenderFns } from "./AnchorCard.vue?vue&type=template&id=4005cdcc&scoped=true&"
import script from "./AnchorCard.vue?vue&type=script&lang=ts&"
export * from "./AnchorCard.vue?vue&type=script&lang=ts&"
import style0 from "./AnchorCard.vue?vue&type=style&index=0&id=4005cdcc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4005cdcc",
  null
  
)

export default component.exports